/**
 * Created by rathompson on 1/19/22
 * File: LoadingCard
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */

const LoadingCard = () => {
  return (
    <div className="tw-animate-pulse tw-flex tw-space-x-4 tw-w-full tw-items-center">
      <div className="tw-rounded-full tw-bg-gray-200 tw-h-10 tw-w-10"/>
      <div className="tw-flex-1 tw-space-y-6 tw-py-1">
        <div className="tw-h-2 bg-gray-200 tw-rounded"/>
        <div className="tw-space-y-3">
          <div className="tw-grid tw-grid-cols-3 tw-gap-4">
            <div className="tw-h-2 tw-bg-gray-200 tw-rounded col-span-2"/>
            <div className="tw-h-2 tw-bg-gray-200 tw-rounded col-span-1"/>
          </div>
          <div className="tw-h-2 tw-bg-gray-200 tw-rounded"/>
        </div>
      </div>
    </div>
  )
}

LoadingCard.propTypes = {}
export default LoadingCard
